import { request } from '@/plugins/http';

/**
 * dbc列表
 * @param params
 * @returns {AxiosPromise}
 */
const getOperatelogList = params => request('/operatelog/getOperatelogList', params);


export {
    getOperatelogList
};
